import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-quotation-create-popup',
  template: `
    <div mat-dialog-title>
      <span>{{'Quotation Create' | translate}}</span>
      <div fxFlex></div>
      <a matTooltip="Close">
        <mat-icon (click)="dialogRef.close()">close</mat-icon>
      </a>
    </div>
    <app-quotation-create mat-dialog-content [inPopup]="true" [data]="data"
                          (onSubmitted)="dialogRef.close(true)"></app-quotation-create>`
})

export class QuotationCreatePopupComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { serviceId: number, client_reference: string, items: any[] },
    public dialogRef: MatDialogRef<QuotationCreatePopupComponent>,
  ) {
  }

  ngOnInit() {
  }
}
